<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <div class="pd-10 bg-white">
      <!-- 返回按钮 -->
      <div
        class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
        @click="$router.push('/SIM/SIMList')"
      >
        <i class="el-icon-arrow-left fw-600"></i>
        返回
      </div>

      <el-descriptions border title="订单详情" class="mgt-20" :column="1">
        <el-descriptions-item label="套餐名称">
          {{ dataInfo.name }}
        </el-descriptions-item>
        <el-descriptions-item label="套餐类型">{{
          dataInfo.packageType
        }}</el-descriptions-item>
        <el-descriptions-item label="支付金额">{{
          dataInfo.payPrice
        }}</el-descriptions-item>
        <el-descriptions-item label="有效时长">
          <span
            v-text="
              dataInfo.validityMoth ? dataInfo.validityMoth + '年' : '- -'
            "
          ></span>
        </el-descriptions-item>
        <el-descriptions-item label="订单编号">{{
          orderNo
        }}</el-descriptions-item>
        <el-descriptions-item label="订单生成时间">{{
          createTime
        }}</el-descriptions-item>
      </el-descriptions>
      <!-- === -->
      <el-descriptions border title="支付方式" class="mgt-20" :column="1">
        <el-descriptions-item label="需付金额" v-if="orderState == '待支付'">
          {{ dataInfo.payPrice }}
        </el-descriptions-item>
        <el-descriptions-item label="支付金额" v-if="orderState !== '待支付'">
          {{ dataInfo.payPrice }}
        </el-descriptions-item>
        <el-descriptions-item label="支付时间" v-if="orderState !== '待支付'">
          {{ payTime }}
        </el-descriptions-item>
        <el-descriptions-item label="订单状态">{{
          orderState
        }}</el-descriptions-item>
        <el-descriptions-item label="支付二维码" v-if="orderState == '待支付'">
          <img class="w200 h200" :src="codeImg" alt="" />
        </el-descriptions-item>
      </el-descriptions>
      <div class="flex jcc mgt-20" v-if="orderState !== '待支付'">
        <el-button @click="$router.push('/SIM/SIMList')">已 知 晓</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      dataInfo: {},
      orderNo: null,
      createTime: null,
      orderState: "待支付",
      codeImg: null,
      timer: null,
      payTime: null,
    };
  },
  created() {
    this.getOrderPay();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getOrderPay() {
      this.$api.sim
        .buyQrCode({
          id: this.$route.query.set,
          num: this.$route.query.num,
        })
        .then((res) => {
          if (res.code === 200) {
            this.orderNo = res.data.orderNo;
            this.codeImg = res.data.code;
            this.dataInfo = res.data;
            this.do();
          }
        });
    },

    getOrder() {
      this.$api.sim.buyOrder({ orderNo: Number(this.orderNo) }).then((d) => {
        if (d.code === 200) {
          this.createTime = d.data.createTime;
          this.payTime = d.data.payTime;
          this.orderState =
            d.data.status == 1
              ? "待支付"
              : d.data.status == 2
              ? "已支付"
              : "- -";
        }
      });
    },
    do() {
      this.getOrder();
      if (this.orderState === "待支付") {
        this.timer = setTimeout(() => {
          this.do();
        }, 10000);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
